// extracted by mini-css-extract-plugin
export var footer = "_sf-0";
export var inherit = "_sf-1";
export var input = "_sf-2";
export var modalContent = "_sf-3";
export var quillEditor = "_sf-4";
export var subtitle = "_sf-5";